<div mat-dialog-content>
    <span [innerHTML]="data.message"></span>
</div>
<div mat-dialog-actions align="end">
    <button mat-stroked-button (click)="close()">Cancel</button>
    <button mat-flat-button color="primary" (click)="confirm()">{{ confirmation }}</button>
</div>
